import Ps from 'perfect-scrollbar';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.min.css';
import './style.less';

export default function ($timeout) {
    return {
        link: function (scope, element, attr) {

            Ps.initialize(element[0], {
                suppressScrollX: true
            });

            $timeout(() => {
                Ps.update(element[0]);
            }, 100);

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/pf-container/index.js